import i18n from '@/utils/i18n';
import React from 'react';
import WalletIcon from '@assets/icons/wallet-add.svg';
import { Button } from '@/components/button';
import { createStyles } from '@/contexts/theme-context';
import { Text, View } from 'react-native';

interface Props {
  onAddPaymentMethod: () => void;
}

export const AutoPayNoPaymentMethodsContainer: React.FC<Props> = ({
  onAddPaymentMethod,
}) => {
  const [styles, theme] = useStyles();

  return (
    <View style={styles.noPaymentMethodsContainer}>
      <WalletIcon
        fill={theme.colors.primary}
        height={40}
        testID="wallet-add-icon"
        width={40}
      />
      <Text style={styles.addPaymentMethodText}>
        {i18n.t('autopay.no_payment_methods')}
      </Text>
      <Button
        onPress={onAddPaymentMethod}
        rounded
        size="small"
        style={styles.addPaymentMethodButton}
        textStyle={styles.addPaymentMethodButtonText}
        trackingData={{ name: 'autopay.add_payment_method' }}
      >
        {i18n.t('add_payment_method')}
      </Button>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  addPaymentMethodButton: {
    backgroundColor: theme.colors.white,
    borderColor: theme.colors.primary,
    borderRadius: 20,
    borderWidth: 1.5,
  },
  addPaymentMethodButtonText: {
    color: theme.colors.primary,
    fontSize: theme.fontSizes.small,
    fontWeight: '600',
    lineHeight: 16,
    paddingHorizontal: 4,
  },
  addPaymentMethodText: {
    color: theme.colors.primary,
    fontSize: theme.fontSizes.medium,
    fontWeight: '400',
    lineHeight: 24,
    textAlign: 'center',
  },
  noPaymentMethodsContainer: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'column',
    gap: 16,
    justifyContent: 'center',
    paddingHorizontal: 50,
  },
}));
